<template>
  <div class="n-text-wrapper">
    <input
      :id="id"
      :type="`text`"
      :class="[`n-text`, disabled && 'disabled']"
      :placeholder="placeholder"
      :readonly="readonly"
      :value="value"
      @input="onInput"
    >

    <div v-if="info" class="hint-wrapper">
      <div class="hint info open">{{ info }}</div>
    </div>

    <div v-else-if="error" class="hint-wrapper">
      <div class="hint error open">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'n-text',

	props: {
		value: {
      type: [ Number, String ],
      default: ''
		},

		id: {
      type: [ Number, String ],
      default: ''
		},

		info: {
			type: String,
			default: ''
		},

		error: {
			type: String,
			default: ''
		},

    placeholder: {
			type: String,
			default: ''
		},

    disabled: {
			type: Boolean,
			default: false
		},

		readonly: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		onInput (e) {
			this.$emit('input', e.target.value);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/common/n-text.vue